import React from "react";
import { DataTable } from "./DataTable";
import { Button } from "antd";
import { YhBox } from "@/components/YhBox";
import { PlusOutlined } from "@ant-design/icons";
import { useNavModel } from "@/model/navModel";
import { useJoinIntention } from "../intentionModel";
import { globalPrompt } from "@/components/message";

export const DataBox = () => {
    
    const { selectedRowKeys, updateEditFormVal } = useJoinIntention();
    const { addNav, findNav, selectNav, switchNavState } = useNavModel(() => []);
    const onEdit = () => {
        if (selectedRowKeys.length !== 1) {
            globalPrompt("message", { text: "请选择单条数据进行编辑，点击鼠标右键可一键选中哦！", type: "warning" });
            return;
        }
        let supplierEditKey = "2-1-2";
        let isFindNav = findNav(supplierEditKey);
        if (!isFindNav) {
            addNav(supplierEditKey, { id: selectedRowKeys[0]?.id as string, mode: "edit" });
            updateEditFormVal(null);
        } else {
            globalPrompt("modal", {
                title: "意向加盟跳转详情",
                type: "warning",
                text: "您还有意向加盟详情未保存，是否跳转",
                okText: "跳转未保存页",
                onOk: () => selectNav(isFindNav ? isFindNav.id : ""),
                cancelText: "打开新页签",
                onCancel: () => {
                    switchNavState(supplierEditKey, { id: selectedRowKeys[0]?.id as string, mode: "edit" });
                    updateEditFormVal(null);
                }
            })
        }
    }

    const action = <>
        <Button
            // className="mr-5"
            shape="round"
            onClick={() => addNav("2-1-1", { id: "", mode: "add" })}
            type="primary"
        ><PlusOutlined /> 新增</Button>
        {/* <Button
            // className="mr-5"
            shape="round"
            onClick={onEdit}
        >编辑</Button>
         <Button
            // className="mr-5"
            shape="round"
            onClick={onEdit}
        >签约</Button> */}
    </>;

    return (
        <YhBox title="" action={action} style={{height:'calc(100vh - 185px)'}}>
            <DataTable />
        </YhBox>
    )
}
